import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const SearchIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={ref}
        >
          <path
            d="M17 17L12.9455 12.954M12.9455 12.954C14.2148 11.6869 15.0001 9.93516 15.0001 7.99997C15.0001 4.13399 11.866 1 8.00003 1C4.13402 1 1 4.13399 1 7.99997C1 11.8659 4.13402 14.9999 8.00003 14.9999C9.93083 14.9999 11.6791 14.2182 12.9455 12.954Z"
            stroke="currentColor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

SearchIcon.displayName = "SearchIcon";
